/** Opens the Enable Location pill/card — used instead of alert() on geolocation failure. */

let openHandler: (() => void) | null = null;

export function registerLocationPromptOpener(handler: (() => void) | null): void {
  openHandler = handler;
}

export function openLocationPrompt(): void {
  openHandler?.();
}
